import { HttpErrorResponse, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppState } from '@core/store';
import { currentUser } from '@core/store/selectors/auth.selectors';
import { Store } from '@ngrx/store';
import { first, map, mergeMap, Observable, of, switchMap, take } from 'rxjs';
import { InterceptStrategy } from './InterceptStrategy';
import { SgdSecurityService } from '../sgdSecurityService';

@Injectable({ providedIn: 'root' })
export class DmsInterceptStrategy implements InterceptStrategy {
	constructor(private storeAppState: Store<AppState>) {}
	private readonly sgdSecurityService: SgdSecurityService;

	isRefreshToken = true;

	isIntercepted(req: HttpRequest<any>): boolean {
		return req.url.includes('api-cluster-dms.sumax.pe');
	}

	additionalParams(req?: HttpRequest<any>): Observable<Record<string, unknown>> {
		return this.storeAppState.select(currentUser).pipe(
			first(),
			mergeMap((user) => {
				const dmsToken = localStorage.getItem('dmsToken');
				let obsConsultaTokenDms$: Observable<string>;
				if (dmsToken === null || dmsToken === undefined || dmsToken === '') {
					obsConsultaTokenDms$ = this.sgdSecurityService.login(user?.sciEmpresa?.nroDocumento).pipe(
						map((data) => {
							localStorage.setItem('dmsToken', data.accessToken);
							return data.accessToken;
						})
					);
				} else {
					obsConsultaTokenDms$ = of(dmsToken);
				}
				return obsConsultaTokenDms$.pipe(
					map(
						(dmsToken) =>
							({
								nroDocumento: user?.sciEmpresa?.nroDocumento || '',
								token: dmsToken,
							} as Record<string, unknown>)
					)
				);
			})
		);
	}

	getHttpRequest(req: HttpRequest<any>, additionalParams?: Record<string, unknown>): HttpRequest<any> {
		const headers = new HttpHeaders({
			Authorization: `Bearer ${additionalParams?.token || ''}`,
			nroDocumento: additionalParams?.nroDocumento?.toString() || '',
		});
		return req.clone({ headers });
	}

	isPosibleTokenExpired(error: HttpErrorResponse): boolean {
		return error.status === 403 || error.status === 401;
	}

	refreshToken(): Observable<Record<string, unknown>> {
		return this.storeAppState.select(currentUser).pipe(
			map((user) => user?.sciEmpresa?.nroDocumento),
			take(1),
			switchMap((nroDocumento) => {
				return this.sgdSecurityService.login(nroDocumento).pipe(
					map((data: any) => {
						localStorage.setItem('dmsToken', data.accessToken);
						return {
							token: data.accessToken,
							nroDocumento: nroDocumento,
						};
					})
				);
			})
		);
	}
}
